// extracted by mini-css-extract-plugin
export default {"variablename":"EditableString_variablename__JMTSl","smallvariablename":"EditableString_smallvariablename__Js09h","rename":"EditableString_rename__y+F-a"};